import React from 'react';
import { Title } from '@vds/typography';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { renderHTML } from '../../../common/Helpers';

// Important Plan Information Modal Body
const IpiModalBody = (props) => (
  <>
    <Title size="large" primitive="h2" bold>
      {props?.modalContent[0].pageTitle}
    </Title>
    &nbsp;
    {props?.modalContent?.map((data) => (
      <>
        <Title size="small" primitive="h3" bold key={data.index}>
          {data?.accordionTitle}
        </Title>
        &nbsp;
        {typeof data?.accordionText === 'string' ? parse(data?.accordionText) : renderHTML(data?.accordionText)}
        {typeof data?.categoryText === 'string' ? parse(data?.categoryText) : renderHTML(data?.categoryText)}
        &nbsp;
      </>
    ))}
  </>
);

IpiModalBody.propTypes = {
  modalContent: PropTypes.array,
};

export default React.memo(IpiModalBody);
